import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { endpoints } from "../../../../services/apiurl";
import { withRouter } from "react-router";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageTitle from "../../../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { MantineReactTable } from "mantine-react-table";
import { InfinitySpin } from "react-loader-spinner";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
const getItems = (ii) =>
  Array.from({ length: ii.length }, (v, k) => k).map((k) => ({
    id: `${ii[k].id}`,
    name: ii[k].name,
    status: `${ii[k].status}`,
    // last: ii[k].id,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

// console.log(localStorage.getItem("user"));

class SubCategoryDetail extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    // console.log(this.props);
    this.state = {
      items: [],
      DataisLoaded: false,
      data: [],
      currentPage: 1,
      totalPages: 1,
      per_page: 10,
      cat_id: this.props.match.params.cat_id,
      rest_id: localStorage.getItem("restro_id"),
      section_id: localStorage.getItem("section_id"),
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    var cat_id = this.state.cat_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios
      .post(endpoints.getSubCategory, {
        page,
        per_page,
        cat_id,
      })
      .then((response) => {
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          local: localStorage.setItem(
            "data",
            JSON.stringify(response.data.data)
          ),
          DataisLoaded: true,
        });
        // console.log(response.data.data);
      });
  }

  move = (data) => {
    var cat_id = this.state.cat_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    this.setState({ DataisLoaded: false });
    axios
      .post(endpoints.subcatupdateSorting, {
        data,
        page,
        per_page,
        cat_id,
      })
      .then((response) => {
        const updatedItems = getItems(response.data.data);

        this.setState({
          items: updatedItems,
          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Error updating dish order:", error);
        // Handle error, show error message, etc.
        this.setState({ DataisLoaded: true });
      });
  };

  removeContactHandler = async (id) => {
    try {
      await axios.post(endpoints.deleteSubCat, { id });

      const newContactList = this.state.items.filter(
        (contact) => contact.id !== id
      );
      // Update the state with the new list using this.setState
      this.setState({ items: newContactList });

      // Show a success toast
      toast.success("Sub Category deleted successfully!");
    } catch (error) {
      // Handle errors if necessary
      console.error("Error deleting contact:", error);
      // Show an error toast
      toast.error("Error deleting item");
    }
  };

  submit = async (id) => {
    confirmAlert({
      title: "DELETE",
      message: "Are you sure you want to Delete it?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            // Call the removeContactHandler function
            await this.removeContactHandler(id);
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  render() {
    const columnss = [
      {
        accessorKey: "name",
        header: "Name",
      },

      {
        accessorKey: "status",
        header: "Status",
      },
      {
        accessorKey: "actions",
        header: "Action",
      },
    ];

    const datas = this.state.items.map((item) => ({
      name: item.name,
      id: item.id,

      status: (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={item.id + "check"}
            checked={item.status === "1"}
            onChange={() => sub(item.id, item.status)}
          />
          <label
            className="custom-control-label"
            style={{ cursor: "pointer" }}
            htmlFor={item.id + "check"}
          ></label>
          <ToastContainer />
        </div>
      ),
      actions: (
        <div className="d-flex align-items-start">
          <Link to={`/dashboard/editsubcategory/${item.id}`}>
            <EditIcon />
          </Link>
          <span
            className="trash alternate outline icon"
            style={{
              color: "red",
              marginTop: "7px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => this.submit(item.id)}
          >
            <ToastContainer />
            <DeleteIcon />
          </span>
        </div>
      ),
    }));
    const { DataisLoaded } = this.state;

    const sub = (id, old_status) => {
      let newStatus = old_status === "1" ? "0" : "1";

      axios
        .post(endpoints.updateSubCatStatus, {
          id,
          status: newStatus,
        })
        .then((response) => {
          this.setState((prevState) => ({
            DataisLoaded: true,
            items: prevState.items.map((item) =>
              item.id === id ? { ...item, status: newStatus } : item
            ),
          }));

          // Display toaster notification for status change
          toast.success(
            `Dish Status ${newStatus === "1" ? "Active" : "Inactive"}`
          );
        })
        .catch((error) => {
          console.error("Error updating status:", error);

          // Display error toaster notification
          toast.error("Error updating dish status");
        });
    };

    const setCurrentPage = (id) => {
      this.state.currentPage = id;
      this.fetchData();
    };

    const onSelectChange = (per_page) => {
      this.state.per_page = per_page;
      this.fetchData();
    };

    return (
      <div className="App">
        <div className="col col-6">
          <label>Row Per Page </label>
          <select
            name="type"
            className="form-control"
            onChange={(e) => onSelectChange(e.target.value)}
            value={this.state.per_page}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        <PageTitle
          title="Sub Category List"
          linkid={this.props.match.params.cat_id}
          linkurl="/dashboard/addsubcategory"
          linkTitle="Add Sub Category"
        />

        <MantineReactTable
          autoResetPageIndex={false}
          columns={columnss}
          data={datas}
          enableRowOrdering
          enableSorting={false}
          enableBottomToolbar={false}
          enablePagination={false}
          mantineRowDragHandleProps={({ table }) => ({
            onDragEnd: () => {
              const { draggingRow, hoveredRow } = table.getState();
              if (hoveredRow && draggingRow) {
                const newData = [...datas];
                const draggedItemId = draggingRow.original.id;

                newData.splice(
                  hoveredRow.index,
                  0,
                 
                  {
                    ...newData.splice(draggingRow.index, 1)[0],
                    id: draggedItemId,
                  }
                );
                //console.log(newData);
                const idIndexMap = {};
                newData.forEach((item, index) => {
                  idIndexMap[item.id] = index;
                });
                // console.log(idIndexMap);

                this.setState({ items: newData });
                this.move(idIndexMap);
              }
            },
            style: { cursor: "grab" },
          })}
        />

        {!DataisLoaded && (
          <div className="spinner">
            <InfinitySpin
              visible={true}
              width="200"
              color="#fbaa1a"
              ariaLabel="infinity-spin-loading"
            />
          </div>
        )}

        <Pagination
          {...bootstrap5PaginationPreset}
          current={this.state.currentPage}
          total={this.state.totalPages}
          onPageChange={(e) => setCurrentPage(e)}
        />
      </div>
    );
  }
}

export default withRouter(SubCategoryDetail);
